// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"EU-z","inlineTitle":"FU-z","sponsoredAdsWrapper":"GU-z","marketplaceRecosWrapper":"HU-z"};